var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secondWrap"},[_c('GoBack',{attrs:{"title":_vm.title,"nextPath":_vm.$route.query.id ? '/donateThird' : '',"nextQuery":_vm.$route.query.id
        ? JSON.stringify({
            title: '项目详情',
            id: _vm.$route.query.id,
            nextPath: '/home',
          })
        : ''}}),(_vm.title === '排行榜')?_c('Rangking'):(_vm.title === '历年捐赠项目')?_c('History'):(_vm.title === '我的捐赠')?_c('MyDonate'):_c('div',{staticStyle:{"margin-top":"47px"}},[_c('SelectTab',{attrs:{"selectTabList":_vm.selectTabList,"curSelectTab":_vm.curSelectTab},on:{"selectTab":_vm.selectTab}}),(_vm.curSelectTab === '捐衣')?_c('ClothesList'):_vm._e(),(_vm.curSelectTab === '捐物')?_c('ThingsList'):_vm._e(),(_vm.curSelectTab === '快捷捐衣')?_c('FastClothes'):_vm._e(),(_vm.curSelectTab === '快捷捐物')?_c('FastThings'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }